"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminMessageDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class AdminMessageDto {}
exports.AdminMessageDto = AdminMessageDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminMessageDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminMessageDto.prototype, "role", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminMessageDto.prototype, "fromUserPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminMessageDto.prototype, "toUserPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminMessageDto.prototype, "content", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], AdminMessageDto.prototype, "isRead", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], AdminMessageDto.prototype, "isFlagged", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminMessageDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminMessageDto.prototype, "updatedAt", void 0);
//# sourceMappingURL=AdminMessage.dto.js.map